/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallForOpportunityPublish } from '../../models/call-for-opportunity-publish';

export interface GetPublicCallForOpportunities$Params {
}

export function getPublicCallForOpportunities(http: HttpClient, rootUrl: string, params?: GetPublicCallForOpportunities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CallForOpportunityPublish>>> {
  const rb = new RequestBuilder(rootUrl, getPublicCallForOpportunities.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CallForOpportunityPublish>>;
    })
  );
}

getPublicCallForOpportunities.PATH = '/publiccallforopportunities';
